<template>
  <div class="modal-overlay" @click="close">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h2>지출 내역 등록</h2>
        <button class="close-btn" @click="close">&times;</button>
      </div>
      <div class="expense-form">
        <div class="form-group">
          <label>카테고리</label>
          <select v-model="expense.category">
            <option value="">카테고리 선택</option>
            <option 
              v-for="category in categories" 
              :key="category.id" 
              :value="category.name"
            >
              {{ category.name }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label>금액</label>
          <input 
            type="number" 
            v-model="expense.amount" 
            placeholder="금액을 입력하세요"
          >
        </div>
        <div class="form-group">
          <label>날짜</label>
          <input 
            type="datetime-local" 
            v-model="expense.date"
          >
        </div>
        <div class="form-actions">
          <button @click="close" class="btn-cancel">취소</button>
          <button @click="submit" class="btn-submit" :disabled="!isValid">등록</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { expenseStore } from '../store/expense'

export default {
  name: 'ExpenseForm',
  data() {
    return {
      expense: {
        category: '',
        amount: '',
        date: new Date().toISOString().slice(0, 16)
      }
    }
  },
  computed: {
    categories() {
      return expenseStore.categories.value
    },
    isValid() {
      return this.expense.category && 
             this.expense.amount && 
             this.expense.date
    }
  },
  methods: {
    async submit() {
      if (!this.isValid) return
      
      try {
        await expenseStore.addExpense(this.expense)
        this.close()
      } catch (error) {
        console.error('지출 등록 실패:', error)
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  animation: modal-in 0.3s ease;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  color: #666;
}

.expense-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: bold;
  font-size: 16px;
}

.form-group input,
.form-group select {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.btn-submit,
.btn-cancel {
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

.btn-submit {
  background-color: #2196F3;
  color: white;
}

.btn-submit:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.btn-cancel {
  background-color: #9e9e9e;
  color: white;
}

@keyframes modal-in {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 모바일 최적화 */
@media (max-width: 600px) {
  .modal-content {
    width: 100%;
    height: 100%;
    border-radius: 0;
    padding: 15px;
  }

  .modal-header h2 {
    font-size: 22px;
  }

  .form-group label {
    font-size: 18px;
  }

  .form-group input,
  .form-group select,
  .btn-submit,
  .btn-cancel {
    font-size: 18px;
    padding: 15px;
  }
}
</style> 